import { AllowanceCalculationType } from '../service-proxies';


export class AllowanceDto implements IAllowanceDto {
    id!: number | undefined;
    allowanceName!: string | undefined;
    allowanceType!: string | undefined;
    isPFCal!: boolean;
    isESICCal!: boolean;
    isLWFCal!: boolean;
    isPTCal!: boolean;
    ranking!: number;
    calculationType!: AllowanceCalculationType;
    calculationTypeName!: string | undefined;
    isActive!: boolean;
    isBonusCal!: boolean;
    isLeaveEncashCal!: boolean;

    constructor(data?: IAllowanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.allowanceName = _data["allowanceName"];
            this.allowanceType = _data["allowanceType"];
            this.isPFCal = _data["isPFCal"];
            this.isESICCal = _data["isESICCal"];
            this.isLWFCal = _data["isLWFCal"];
            this.isPTCal = _data["isPTCal"];
            this.ranking = _data["ranking"];
            this.calculationType = _data["calculationType"];
            this.calculationTypeName = _data["calculationTypeName"];
            this.isActive = _data["isActive"];
            this.isBonusCal = _data["isBonusCal"];
            this.isLeaveEncashCal = _data["isLeaveEncashCal"];
        }
    }

    static fromJS(data: any): AllowanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allowanceName"] = this.allowanceName;
        data["allowanceType"] = this.allowanceType;
        data["isPFCal"] = this.isPFCal;
        data["isESICCal"] = this.isESICCal;
        data["isLWFCal"] = this.isLWFCal;
        data["isPTCal"] = this.isPTCal;
        data["ranking"] = this.ranking;
        data["calculationType"] = this.calculationType;
        data["calculationTypeName"] = this.calculationTypeName;
        data["isActive"] = this.isActive;
        data["isBonusCal"] = this.isBonusCal;
        data["isLeaveEncashCal"] = this.isLeaveEncashCal;
        return data; 
    }
}

export interface IAllowanceDto {
    id: number | undefined;
    allowanceName: string | undefined;
    allowanceType: string | undefined;
    isPFCal: boolean;
    isESICCal: boolean;
    isLWFCal: boolean;
    isPTCal: boolean;
    ranking: number;
    calculationType: AllowanceCalculationType;
    calculationTypeName: string | undefined;
    isActive: boolean;
    isBonusCal: boolean;
    isLeaveEncashCal: boolean;
}

